import { useDispatch } from "react-redux";
import { AppDispatch } from "store/appStore";

export const useAppDispatch = () => useDispatch<AppDispatch>();
